export interface BtnClassOptions {
  btnType?: 'type-a' | 'type-b' | 'type-c' | 'type-d' | 'type-e';
  size?: 'none' | 'medium' | 'large' | 'x-large';
  side?: 'left' | 'right';
  disabled?: boolean;
  fullWidth?: boolean;
}

// Class map matching the .btn system in scss/atomics/_button.scss (formerly TrButton.vue's customClass getter).
export function btnClasses(options: BtnClassOptions = {}): Record<string, boolean> {
  const {btnType = 'type-a', size = 'large', side = 'right', disabled = false, fullWidth = false} = options;

  return {
    'btn__type-a': btnType === 'type-a',
    'btn__type-b': btnType === 'type-b',
    'btn__type-c': btnType === 'type-c',
    'btn__type-d': btnType === 'type-d',
    'btn__type-e': btnType === 'type-e',
    'btn--size-none': size === 'none',
    'btn--size-med': size === 'medium',
    'btn--size-large': size === 'large',
    'btn--size-x-large': size === 'x-large',
    'btn--icon-left': side === 'left',
    'btn--icon-right': side === 'right',
    'btn--disabled': disabled,
    'btn--full-width': fullWidth,
  };
}
